import styles from './TableLineContainer.module.scss'

export const presets = {
  primary: styles.container,
  material: styles.material
}
